module.exports = __webpack_public_path__ + "img/gear-I_56x56.e2bebd40.png";